/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_footer__newsletter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Unseren Newsletter abonnieren`
};

const en_footer__newsletter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Subscribe to our Newsletter`
};

const es_footer__newsletter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Suscríbase a nuestro boletín`
};

const fr_footer__newsletter_button = /** @type {(inputs: {}) => string} */ () => {
	return `S'inscrire à notre Newsletter`
};

const it_footer__newsletter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Abbonati alla nostra newsletter`
};

const nl_footer__newsletter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Abonneer je op onze nieuwsbrief`
};

const pt_footer__newsletter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Subscrever a nossa Newsletter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const footer__newsletter_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer__newsletter_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer__newsletter_button", locale)
	if (locale === "de") return de_footer__newsletter_button(inputs)
	if (locale === "en") return en_footer__newsletter_button(inputs)
	if (locale === "es") return es_footer__newsletter_button(inputs)
	if (locale === "fr") return fr_footer__newsletter_button(inputs)
	if (locale === "it") return it_footer__newsletter_button(inputs)
	if (locale === "nl") return nl_footer__newsletter_button(inputs)
	return pt_footer__newsletter_button(inputs)
};